import useSWR from 'hooks/useSWR';
import { LabelDTO } from 'types/company';
import { useSWRResource } from 'util/resource/useSWRResource';
import { communitiesApi, communityAPIUrls } from './communitiesApi';
import { List } from 'types/api';
import useResource from 'util/resource/useResource';

export const communityLabelsKey = (communitySlug: string) => communityAPIUrls.labels.list(communitySlug);

export const useCommunityLabels = (communitySlug: string) => {
  const response = useSWR<List<LabelDTO>>(communityLabelsKey(communitySlug));
  return useSWRResource(response);
};

export const useCommunityCompanyLabels = (canSeeLabels: boolean, communityId: number, companyId: number) =>
  useResource<List<LabelDTO>>(
    canSeeLabels ? communitiesApi.communityMemberLabels.get(communityId, companyId) : undefined,
  );
